





























































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from "@vue/composition-api";
import { required, sameAs } from "@vuelidate/validators";
import { useMachine } from "@xstate/vue";
import useVuelidate from "@vuelidate/core";

import { AuthenticationApi } from "@/api";
import isPassword from "@/util/validators/password";
import { mapValidationErrors } from "@/util/Forms";
import ResetPasswordMachine from "./ResetPasswordMachine";

interface PasswordResetForm {
  valid: boolean;
  errors: {};
  fields: {
    passwordResetToken: string;
    password: string;
    passwordRepeat: string;
  };
  validations: {};
}

const Component = defineComponent({
  setup(props, vm) {
    const password = ref("");
    const passwordRepeat = ref("");

    const { state, send, service } = useMachine(ResetPasswordMachine);
    const api = new AuthenticationApi();

    const form: PasswordResetForm = reactive({
      valid: false,

      fields: {
        passwordResetToken: "",
        password,
        passwordRepeat,
      },

      errors: {},

      validations: useVuelidate(
        {
          password: {
            required,
            password: isPassword,
            $autoDirty: true,
          },
          passwordRepeat: {
            required,
            sameAs: sameAs(password),
            $autoDirty: true,
          },
        },
        {
          password,
          passwordRepeat,
        }
      ),
    });

    async function verifyResetToken(passwordResetToken: string) {
      try {
        await api.authenticationIsPasswordResetTokenValid({
          passwordResetToken,
        });
        form.fields.passwordResetToken = passwordResetToken;
        service.send("RESOLVE");
      } catch (err) {
        service.send("REJECT");
      }
    }

    async function passwordReset() {
      try {
        await api.authenticationResetPassword({
          passwordResetToken: form.fields.passwordResetToken,
          password: form.fields.password,
        });
        service.send("RESOLVE");
      } catch (err) {
        form.errors = err.response.data.errors;
        service.send("REJECT");
      }
    }

    onMounted(() => {
      if (vm.root.$route.params.token) {
        verifyResetToken(vm.root.$route.params.token);
      } else {
        service.send("REJECT");
      }

      service.subscribe((s) => {
        if (s.matches("loading")) {
          passwordReset();
        }
      });
    });

    return {
      form,
      mapValidationErrors,
      service,
      send,
      state,
    };
  },
});

export default Component;
